import { faDumpsterFire } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Sentry from "@sentry/react";
import { Result } from "antd";
import React, { useCallback, useEffect, useState } from "react";

interface Props {
    children: React.ReactNode;
}

const MapErrorBoundary: React.FC<Props> = (props) => {
    const [hasError, setHasError] = useState(false);

    const handleError = useCallback((error: Error | null) => {
        // The spec says type of "any", and not all errors may be instances of Error, so we allow null and check for it.
        // We have had a large amount of errors happening im sentry over the past 2 years that just don't actually come with an error object.
        // Largely being seen on the map being unmounted or unavailable.
        if (!error) {
            return;
        }

        Sentry.captureMessage(error.message);
        setHasError(true);
    }, []);

    const errorHandler = useCallback(
        (event: ErrorEvent) => {
            handleError(event.error);
        },
        [handleError]
    );

    useEffect(() => {
        window.addEventListener("error", errorHandler);

        return () => {
            window.removeEventListener("error", errorHandler);
        };
    }, [errorHandler]);

    if (hasError) {
        return (
            <div className="w-full flex items-center justify-center bg-white">
                <Result
                    title="Error"
                    subTitle="Sorry, map is currently unavailable"
                    icon={<FontAwesomeIcon icon={faDumpsterFire} size="6x" color="#ff9e00" />}
                />
            </div>
        );
    }

    return <>{props.children}</>;
};

export default MapErrorBoundary;
